import { z } from 'zod';
import { SourceSystem } from '../enums.js';
import { IsoDateTime, UuidString } from '../primitives.js';

/**
 * Manufacturer — справочник производителей материалов/компонентов.
 * Один и тот же компонент (например, feed spacer 0.61mm) может поставляться
 * разными заводами (WECOME / BEISEN / OVAY) — это разные Manufacturer.
 *
 * Поставщик (impórter, trading partner) — это Counterparty (S14), не Manufacturer.
 */
export const Manufacturer = z.object({
  id: UuidString,
  entity_id: UuidString,
  code: z.string().min(1),
  name: z.string().min(1),
  country_code: z.string().length(2).nullable().default(null),
  website: z.string().url().nullable().default(null),
  is_active: z.boolean().default(true),
  source_system: SourceSystem.default('staiter'),
  source_document_id: z.string().nullable(),
  source_system_ref: z.record(z.unknown()).nullable(),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type Manufacturer = z.infer<typeof Manufacturer>;

/**
 * ItemManufacturer — junction N:M между Item и Manufacturer.
 * Фиксирует, что у данного Item существует альтернатива от конкретного производителя,
 * с его Manufacturer Part Number (MPN) и спецификацией.
 *
 * is_default — предпочтительный производитель (один на Item).
 */
export const ItemManufacturer = z.object({
  id: UuidString,
  entity_id: UuidString,
  item_id: UuidString,
  manufacturer_id: UuidString,
  mpn: z.string().min(1),
  /** Текстовая спецификация как напечатана на упаковке/в каталоге производителя. */
  manufacturer_spec: z.string().nullable().default(null),
  is_default: z.boolean().default(false),
  notes: z.string().nullable().default(null),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type ItemManufacturer = z.infer<typeof ItemManufacturer>;
